// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"19e96a3c","207":"e8637b47","328":"23880f35","421":"5bcc4951","691":"65550623","692":"5d3f72c8","824":"e8637b47"}[chunkId] + ".chunk.css";
};